<div class="w-[100%] p-[20px] pb-[30px] pt-[20px] pl-[15px]">
  <div class="flex">
    <div class="flex flex-col justify-start   gap-y-[1.25rem] items-start w-[25%]" style="
    row-gap: 1.6rem;
">
      <div class="flex flex-col items-start">
        <p class="attribute-header">Project Type</p>
        <p class="attribute-value">
          {{ eoiData?.projectDetails?.project_type?.name || "Not Selected" }}
        </p>
      </div>

      <div class="flex flex-col items-start">
        <p class="attribute-header">Grade</p>
        <p class="attribute-value">
          {{ eoiData?.projectDetails?.grade?.name || "Not Selected" }}
        </p>
      </div>

      <div class="flex flex-col items-start">
        <p class="attribute-header">Start Date</p>
        <p class="attribute-value">
          {{
            eoiData?.projectDetails?.start_date
              ? (eoiData?.projectDetails?.start_date | date : "yyyy-MM-dd")
              : "Not Selected"
          }}
        </p>
      </div>

      <div class="flex flex-col items-start">
        <p class="attribute-header">End Date</p>
        <p class="attribute-value">
          {{
            eoiData?.projectDetails?.end_date
              ? (eoiData?.projectDetails?.end_date | date : "yyyy-MM-dd")
              : "Not Selected"
          }}
        </p>
      </div>

      <div class="flex flex-col items-start">
        <p class="attribute-header">Country</p>
        <p class="attribute-value">
          {{ eoiData?.projectDetails?.country?.name || "Not Selected" }}
        </p>
      </div>

      <div class="flex flex-col items-start">
        <p class="attribute-header">city</p>
        <p class="attribute-value">
          {{ eoiData?.projectDetails?.city || "Not Selected" }}
        </p>
      </div>

      <div class="flex flex-col items-start">
        <p class="attribute-header">Zip Code</p>
        <p class="attribute-value">
          {{ eoiData?.projectDetails?.zip || "Not Selected" }}
        </p>
      </div>

      <div class="flex flex-col items-start">
        <p class="attribute-header">Street</p>
        <p class="attribute-value">
          {{ eoiData?.projectDetails?.street || "Not Selected" }}
        </p>
      </div>
    </div>
    <div class="w-[75%]">
      <p class="intro flex justify-start  !mb-0">Brief</p>
      <p
        class="breif-value"
        [innerHTML]="getSanitizedHtml(eoiData?.projectDetails?.description)"
      ></p>

      <div class="flex justify-between w-[100%]">
        <div class="w-[50%]">
          <p class="intro flex justify-start !mt-[29px] !mb-0">
            Site Conditions
          </p>
          <p
            class="breif-value"
            [innerHTML]="
              getSanitizedHtml(eoiData?.projectDetails?.site_conditions)
            "
          ></p>
          <p class="intro flex justify-start !mt-[29px] !mb-0">
            Key Deliverables
          </p>

          <ul class="!pl-0 mt-[7px]">
            <div
              class="flex"
              *ngFor="let goals of eoiData?.projectDetails?.goals"
            >
              <div class="flex">
                <span class="">{{ goals?.name }}</span>
              </div>
            </div>
          </ul>
        </div>
        <div class="ml-[10px] w-[50%] pt-[39px]">
          <div class="flex-1 flex items-center justify-end">
            <iframe
              width="90%"
              height="244px"
              style="border: 0"
              loading="lazy"
              [src]="mapLink"
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
